import { useContext, useState, useEffect, useRef } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { logoutURL } from '../../constants/urls'
import { publicacionesVencidas } from '../../helpers/notificarSobrePublicacionesVencidas.js'
import { CarritoContext } from '../context/carritoContext'
import { LoginContext } from '../context/loginContext'
import { MenuContext } from '../context/menuContext'
import ImagenPerfil from '../imagen/ImagenPerfil'
import MenuFavoritos from '../MenuFavoritos'
import { buscarTodasOptimizado } from '../servicios/publicacionesService'
import LinkButton from '../ui/LinkButton'
import styles from './Cabecera.module.css'
import CabeceraBuscador from './CabeceraBuscador'
import DropdownNotificacion from './DropdownNotificacion'

const TIMEOUT_REVOKE_TOKEN = 30000

const Cabecera = () => {
  const { desplegarMenu, menuAbierto } = useContext(MenuContext)
  const { cantidad, setVerCarrito } = useContext(CarritoContext)
  const { loginDataContext, logout, renewToken } = useContext(LoginContext)
  const [showAviso, setShowAviso] = useState(false)
  const [refreshNotificaciones, setRefreshNotificaciones] = useState(false)
  const timeRevoke = useRef()
  const time = useRef()

  const handleRevokeToken = () => {
    logout()
    setShowAviso(false)
    window.location.href = logoutURL
  }

  const handleRefreshToken = () => {
    renewToken()
    clearTimeout(timeRevoke.current)
    avisoSesionEstado()
    setShowAviso(false)
  }

  const showSessionWarning = () => {
    if (localStorage.getItem('refreshjwt') !== null) {
      setShowAviso(true)
      timeRevoke.current = setTimeout(() => {
        handleRevokeToken()
      }, TIMEOUT_REVOKE_TOKEN)
      return () => clearTimeout(timeRevoke.current)
    }
  }

  const avisoSesionEstado = () => {
    time.current = setTimeout(
      () => {
        showSessionWarning()
        return () => clearTimeout(time.current)
      },
      import.meta.env.VITE_EXPIRATION_TIME
    )
  }

  const resetTimer = () => {
    clearTimeout(time.current)
    avisoSesionEstado()
  }

  useEffect(() => {
    avisoSesionEstado()
    window.addEventListener('click', () => resetTimer())
    window.addEventListener('keypress', () => resetTimer())
  }, [])

  function display() {
    document.getElementById('userlike')
  }

  const fetchData = async () => {
    const { data } = await buscarTodasOptimizado(0, loginDataContext.idUsuario, 0, '')
    if (data.length > 0) {
      const inserto = await publicacionesVencidas(data, loginDataContext.idUsuario)
      if (inserto) {
        setRefreshNotificaciones(true)
      }
    }
  }

  useEffect(() => {
    if (loginDataContext.idUsuario) {
      fetchData()
    }
  }, [loginDataContext.idUsuario])

  //Se renderiza el widget de userlike.
  useEffect(() => {
    const script = document.createElement('script')
    script.src =
      'https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/8f10a28d8659d9ba111b24662ad4259ac1b63e516f55ddbfbb8aa1c7dd5f302e.js'
    script.async = true
    document.body.appendChild(script)
    setTimeout(display, '1000')
    return () => document.body.removeChild(script)
  }, [])

  return (
    <>
      {/* Main header row with 3 columns */}
      <div
        style={{
          display: 'flex',
          alignItems: 'stretch',
          padding: '10px 15px 0 15px',
          height: '100%'
        }}
      >
        {/* Column 1: Logo on top, Menu + Profile below */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minWidth: '250px',
            width: '250px',
            gap: '5px',
            height: '100%'
          }}
        >
          {/* First div: Logo */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center'
            }}
          >
            <div className="d-none d-lg-block">
              <Link id={styles.ebm} onClick={handleRevokeToken}>
                e-buymarket<span className={styles.com}>.com</span>
              </Link>
            </div>
          </div>

          {/* Second div: Menu + Profile */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              width: '100%'
            }}
          >
            {/* Menu - always visible */}
            <label
              className="icon-menu"
              htmlFor="menu-bar"
              data-bs-toggle="collapse"
              onClick={() => desplegarMenu(!menuAbierto)}
              style={{
                cursor: 'pointer',
                color: '#fff',
                fontSize: '18px',
                paddingLeft: '2em',
                paddingTop: '0.8em',
                paddingRight: '1em'
              }}
            >
              <i className={`fa ${menuAbierto ? 'fa-times' : 'fa-bars'}`} aria-hidden="true" />
            </label>

            {/* Profile Image and Name */}
            {localStorage.getItem('empid') && localStorage.getItem('idUsuario') && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  flex: 1,
                  justifyContent: 'center',
                  height: '100%'
                }}
              >
                {/* Profile Image - centered and bigger */}
                <Link to="/Perfil">
                  <div className={styles.cont_perfil_img}>
                    <ImagenPerfil
                      idUsuario={parseInt(localStorage.getItem('idUsuario'))}
                      clase={styles.perfil_img}
                    />
                  </div>
                </Link>

                {/* Profile Name - centered horizontally, bottom vertically */}
                <div
                  className="cont-perfil"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end', // Positions content at bottom
                    alignItems: 'center', // Centers content horizontally
                    height: '100%' // Takes full height of parent
                  }}
                >
                  <Link className={styles.perfil} to="/Perfil">
                    {loginDataContext.nombre}
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Column 2: Search Bar and MenuFavoritos (grows to fill space) */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '0 20px',
            height: '100%'
          }}
        >
          {/* Search Bar */}
          <div
            id="contenedorPadreSearch"
            style={{ width: '100%', maxWidth: '600px', marginBottom: '5px' }}
          >
            <div
              id="contenedorSearch"
              className="d-flex justify-content-center align-items-center w-100"
            >
              <CabeceraBuscador />
            </div>
          </div>

          {/* Menu Favoritos below search */}
          <div
            className={`${styles.barra_acceso_directo}`}
            style={{
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
              width: '100%'
            }}
          >
            <MenuFavoritos />
          </div>
        </div>

        {/* Column 3: Logout at top, Notifications + Cart at bottom */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            minWidth: '250px',
            height: '100%',
            position: 'relative'
          }}
        >
          {/* Top: Logout Button */}
          <div
            style={{
              alignSelf: 'flex-end',
              marginRight: '6px',
              marginTop: '16px'
            }}
          >
            <Button variant="danger" onClick={handleRevokeToken}>
              <i className="fa fa-sign-out" aria-hidden="true" style={{ marginRight: '8px' }} />
              Salir
            </Button>
          </div>

          {/* Bottom: Notifications + Cart - positioned at absolute bottom */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              justifyContent: 'flex-end',
              marginRight: '6px',
              marginBottom: '14px'
            }}
          >
            {/* Notifications */}
            <div id="esUnificado">
              <DropdownNotificacion refreshKey={refreshNotificaciones} />
            </div>

            {/* Cart */}
            <div id="contenedorNotificacionCarrito">
              <Link
                to={'/Carrito'}
                id="notificacion-carrito"
                className="btn btn-notificaciones"
                onClick={() => setVerCarrito(false)}
              >
                <i
                  className="fa fa-shopping-cart"
                  aria-hidden="true"
                  style={{ marginRight: '8px' }}
                />
                <span className="badge badge-light">{cantidad}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

      <Modal
        show={showAviso}
        onHide={handleRevokeToken}
        backdrop={'static'}
        className="w-25 ml-auto mr-auto"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Psst!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              ¿Sigues ahí?..
              <br />
              Si no confirmas, tu sesión finalizará.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <LinkButton className="btn btn-danger" to="/login/" onClick={() => handleRevokeToken()}>
            Cerrar Sesión
          </LinkButton>
          <LinkButton className="btn btn-comprar" onClick={() => handleRefreshToken()}>
            ¡Aún sigo aquí!
          </LinkButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Cabecera
